module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av427-3fd5f2a3b1251cde180ddb05580efc7f.jpg";